import { render, staticRenderFns } from "./projectsTask.vue?vue&type=template&id=0df25990&"
import script from "./projectsTask.vue?vue&type=script&lang=js&"
export * from "./projectsTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports